module.exports = __webpack_public_path__ + "img/saska-m.dc8ff93d.jpg";